import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const navItems = [
    { name: 'ホーム', path: '/' },
    { name: 'コース・料金', path: '/course' },
    { name: '定期テスト対策', path: '/test' },
    { name: '高校受験対策', path: '/exam' },
    { name: '塾について', path: '/about' },
    { name: 'アクセス', path: '/access' },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-white/90 backdrop-blur-sm'
        }`}
      >
        <nav className="mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/d25d902e8f85acdeaade0dc2a90c4947.jpg" 
                alt="学習塾NICK" 
                className="h-12 w-auto object-contain"
              />
              <span className="text-xl font-bold text-[#1a2332]">学習塾NICK</span>
            </Link>

            <div className="hidden lg:flex items-center gap-8">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-sm font-medium transition-colors hover:text-[#4a90e2] whitespace-nowrap ${
                    location.pathname === item.path ? 'text-[#4a90e2]' : 'text-[#1a2332]'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </div>

            <div className="flex items-center gap-3">
              <Link
                to="/trial#trial-form-section"
                className="hidden sm:flex bg-[#4a90e2] text-white px-6 py-3 rounded-full font-medium hover:bg-[#3a7bc8] transition-all hover:scale-105 items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                無料体験
                <i className="ri-arrow-right-line"></i>
              </Link>

              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md hover:bg-gray-100 transition-colors cursor-pointer"
                aria-label="メニュー"
              >
                <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl text-[#1a2332]`}></i>
              </button>
            </div>
          </div>
        </nav>
      </header>

      {/* モバイルメニューオーバーレイ */}
      <div
        className={`fixed inset-0 bg-black/40 z-40 transition-opacity duration-300 lg:hidden ${
          isMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsMenuOpen(false)}
      />

      {/* モバイルメニュードロワー */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-white z-50 shadow-xl transition-transform duration-300 ease-in-out lg:hidden ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
          <span className="text-lg font-bold text-[#1a2332]">メニュー</span>
          <button
            onClick={() => setIsMenuOpen(false)}
            className="w-9 h-9 flex items-center justify-center rounded-md hover:bg-gray-100 transition-colors cursor-pointer"
            aria-label="閉じる"
          >
            <i className="ri-close-line text-xl text-[#1a2332]"></i>
          </button>
        </div>

        <div className="flex flex-col py-4">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`px-6 py-3.5 text-sm font-medium transition-colors ${
                location.pathname === item.path
                  ? 'text-[#4a90e2] bg-blue-50/60'
                  : 'text-[#1a2332] hover:bg-gray-50'
              }`}
            >
              {item.name}
            </Link>
          ))}
        </div>

        <div className="px-6 pt-4 border-t border-gray-100">
          <Link
            to="/trial#trial-form-section"
            className="flex items-center justify-center gap-2 w-full bg-[#4a90e2] text-white py-3 rounded-full font-medium hover:bg-[#3a7bc8] transition-all cursor-pointer whitespace-nowrap"
          >
            無料体験に申し込む
            <i className="ri-arrow-right-line"></i>
          </Link>
          <a
            href="tel:0829-78-1638"
            className="flex items-center justify-center gap-2 w-full mt-3 border border-[#1a2332] text-[#1a2332] py-3 rounded-full font-medium hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            0829-78-1638
          </a>
        </div>
      </div>
    </>
  );
}
